import React, { ReactNode } from 'react';
import classNames from 'classnames';
import './menu-item.less'

interface IMenuItemsProps {
    children: ReactNode; // 用户自定义的菜单内容
    special?: boolean;//是否是删除选项
    onClick?: (e) => void; // 点击事件
    wrapClassName?: string; // 外层容器的自定义类名
    style?: React.CSSProperties; // 按钮样式
    disabled?: boolean;
}

export default function MenuItem(props: IMenuItemsProps) {

    const { children, wrapClassName, onClick, special, style,disabled } = props;

    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return; // 阻止事件传播并不触发 `onClick`
        }
        onClick?.(e);
    };


    return (
        <div className={classNames({
            "menu-item": true,
            "special": special,
            'disabled': disabled,
        }, wrapClassName)} onClick={handleClick} style={style}>
            {children}
        </div>
    );
}
